module.exports = __webpack_public_path__ + "img/smarthelp2_header.192c61e2.png";